import React, { useCallback, useState } from "react";
import { formatAmount } from "../../../OperationsJournal/mock/operationsJournalMock";
import ConfirmDialog from "../../../shared/recognition/ui/ConfirmDialog";
import SelectionBar from "../SelectionBar/SelectionBar";
import { AllocationTable, SummaryList } from "../AllocationDetails/AllocationDetails";
import { ONLY_THIS_RECORD_NOTE } from "../../constants";
import { getBaseLabel } from "../../utils/allocationBase";

const MAX_LISTED_DOCUMENTS = 5;

const getDocumentsLabel = (operations) => {
  const listed = operations
    .slice(0, MAX_LISTED_DOCUMENTS)
    .map((operation) => operation.document)
    .join(", ");
  const rest = operations.length - MAX_LISTED_DOCUMENTS;
  return rest > 0 ? `${listed} и ещё ${rest}` : listed;
};

/**
 * Шаг 4: сводка параметров, итоговое распределение и подтверждение создания проводок.
 * restartOf — запись реестра, которую перезапускают: её проводки будут заменены новыми.
 */
function ReviewStep({
  operations,
  totalAmount,
  base,
  allocation,
  restartOf,
  onBack,
  onConfirm,
}) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const closeConfirm = useCallback(() => setIsConfirmOpen(false), []);

  const baseLabel = getBaseLabel(base);
  const entriesCount = operations.length * allocation.rows.length;
  const actionLabel = restartOf ? "Перезапустить" : "Создать проводки";

  const summary = [
    { label: "Исходных операций", value: operations.length },
    { label: "Документы", value: getDocumentsLabel(operations) },
    { label: "Получателей", value: allocation.rows.length },
    { label: "База", value: baseLabel },
    ...(restartOf
      ? [{ label: `Будет удалено проводок ${restartOf.document}`, value: restartOf.entries.length }]
      : []),
    { label: "Будет создано проводок", value: entriesCount },
    { label: "Сумма", value: formatAmount(totalAmount), accent: true },
  ];

  const confirmRows = [
    ...(restartOf ? [{ label: "ID", value: restartOf.document }] : []),
    { label: "Исходных операций", value: operations.length },
    { label: "Получателей", value: allocation.rows.length },
    { label: "Сумма", value: formatAmount(totalAmount) },
    { label: "База", value: baseLabel },
    ...(restartOf
      ? [
          { label: "Будет удалено проводок", value: restartOf.entries.length },
          { label: "Будет создано проводок", value: entriesCount },
        ]
      : []),
  ];

  return (
    <div className="al-review">
      <h3 className="al-section-title">Проверьте параметры распределения</h3>

      <div className="al-review__content">
        <SummaryList rows={summary} />
        <AllocationTable title="Итоговое распределение" rows={allocation.rows} />
      </div>

      <SelectionBar
        onBack={onBack}
        continueLabel={actionLabel}
        continueDisabled={Boolean(allocation.error)}
        onContinue={() => setIsConfirmOpen(true)}
      />

      <ConfirmDialog
        isOpen={isConfirmOpen}
        title={restartOf ? "Перезапустить распределение?" : "Создать распределение?"}
        rows={confirmRows}
        note={
          restartOf
            ? `Проводки ${restartOf.document} будут удалены и сформированы заново с указанными параметрами. ${ONLY_THIS_RECORD_NOTE}`
            : "После подтверждения система сформирует управленческие операции распределения."
        }
        confirmLabel={actionLabel}
        onCancel={closeConfirm}
        onConfirm={() => {
          setIsConfirmOpen(false);
          onConfirm();
        }}
      />
    </div>
  );
}

export default ReviewStep;
